import React from 'react';

import {
  Typography
} from '@material-ui/core';
import { Grid } from '@mui/material';
import { classes } from '../../components/Map/classes';
import { MapContext } from '../../contexts/MapFilterContext';
import Neighborhood from '../../components/Map/Filters/Neighborhood';
import Area from '../../components/Map/Filters/Area';
import Group from '../../components/Map/Filters/Group';
import State from '../../components/Map/Filters/State';
import Status from '../../components/Map/Filters/Status';
import Late from '../../components/Map/Filters/Late';
import Period from '../../components/Map/Filters/Period';
import Target from '../../components/Map/Filters/Target';
import StepStatus from '../../components/Map/Filters/StepStatus';

export default function Filters() {

  return (
    <div className="filtros-mapa">
      <Typography variant="h5" align="center" style={classes.textTitle}>
        Ocorrências Comuns
      </Typography>

      <div id='filters-grid'>
        <Grid container spacing={2} justifyContent='center'>
          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <Neighborhood context={MapContext} />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <Area context={MapContext} />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <Group context={MapContext} />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
            <State context={MapContext} />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
            <Status context={MapContext} />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
            <StepStatus context={MapContext} />
          </Grid>

          <Grid item xs={12} sm={6} md={4} lg={4} xl={3}>
            <Late context={MapContext} />
          </Grid>

          <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
            <Period context={MapContext} />
          </Grid>

          <Grid item xs={12} sm={12} md={4} lg={4} xl={3}>
            <Target context={MapContext} />
          </Grid>
        </Grid>
      </div>
    </div >
  )
}